module.exports = __webpack_public_path__ + "static/media/Unbatch.43fc70b2.svg";